export const T = {
  en_GB: {
    productCorrelations: "Product Correlations",
    description:
      "Define correlation values between products. Values range from -1 (perfect negative correlation) to 1 (perfect positive correlation). Enter values manually or upload a CSV.",
    loadingCorrelations: "Loading correlations...",
    correlationsSaved: "Saved",
    save: "Save",
    product: "Product",
    helpText: "Enter a correlation value for each product pair, then Save to persist.",
    failedToSave: "Failed to save correlations",
    valuesOutOfRange: "Correlation values must be between -1 and 1",
    collapsedTitle: "Correlation matrix hidden",
    collapsedReason: (count: number, limit: number) =>
      `This collection has ${count} products — above the ${limit}-item display limit, so the full grid is hidden to keep this page usable.`,
    correlationsStatus: (defined: number, required: number) =>
      `${defined}/${required} correlations are ok`,
    correlationsStatusHint:
      "A pair counts as ok once a value between -1 and 1 is stored for it. Forecasts need every pair: a missing one stops the calculation and is named in the error.",
    downloadCsv: "Download CSV",
    uploadCsv: "Upload CSV",
    csvUploaded: "Saved",
    failedToParseCsv: "Could not import CSV",
    duplicateIsinsBlockCsv:
      "Two or more products share the same ISIN — fix that to use CSV import/export.",
    productsWithoutIsinExcluded: (count: number) =>
      `${count} product${count === 1 ? "" : "s"} without an ISIN ${count === 1 ? "is" : "are"} not included in the CSV — add an ISIN on the product to include it.`,
  },
  nb_NO: {
    productCorrelations: "Produktkorrelasjoner",
    description:
      "Definer korrelasjonsverdier mellom produkter. Verdier varierer fra -1 (perfekt negativ korrelasjon) til 1 (perfekt positiv korrelasjon). Angi verdier manuelt eller last opp en CSV.",
    loadingCorrelations: "Laster korrelasjoner...",
    correlationsSaved: "Lagret",
    save: "Lagre",
    product: "Produkt",
    helpText: "Angi en korrelasjonsverdi for hvert produktpar, og lagre deretter.",
    failedToSave: "Kunne ikke lagre korrelasjoner",
    valuesOutOfRange: "Korrelasjonsverdier må være mellom -1 og 1",
    collapsedTitle: "Korrelasjonsmatrise skjult",
    collapsedReason: (count: number, limit: number) =>
      `Denne samlingen har ${count} produkter — over visningsgrensen på ${limit}, så hele rutenettet er skjult for å holde siden brukbar.`,
    correlationsStatus: (defined: number, required: number) =>
      `${defined}/${required} korrelasjoner er ok`,
    correlationsStatusHint:
      "Et par regnes som ok når det er lagret en verdi mellom -1 og 1 for det. Prognosene trenger alle par: et manglende par stopper beregningen og navngis i feilmeldingen.",
    downloadCsv: "Last ned CSV",
    uploadCsv: "Last opp CSV",
    csvUploaded: "Lagret",
    failedToParseCsv: "Kunne ikke importere CSV",
    duplicateIsinsBlockCsv:
      "To eller flere produkter har samme ISIN — rett dette for å bruke CSV-import/eksport.",
    productsWithoutIsinExcluded: (count: number) =>
      `${count} produkt${count === 1 ? "" : "er"} uten ISIN er ikke med i CSV-en — legg til en ISIN på produktet for å inkludere det.`,
  },
} as const;
